<template>
  <div>
    <div class="above-nav">
      <a class='list' tag='li' href="/">
        <img src="./logo.png" alt="logo" height="40">
      </a>
      <div class="QR">
        关注公众号：全优在线
        <div class="code">
          <div class="img-wrapper">
            <img src="./qr-code.jpg" alt="qr-code" width="100%" height="100%">
          </div>
          <p class="img-title">打开微信扫一扫并关注</p>
          <p class="code-text">关注公众号接收上课和报名最新消息</p>
        </div>
      </div>
      <span class="create-class" style="cursor: pointer; float: right; color: #fff; font-size: 13px; display: flex; align-items: center; height: 40px"
            @click="$store.commit('setAddClassDialog', true)">
        <i class="el-icon-circle-plus-outline" style="font-size: 15px; margin-right: 3px"></i>
        <span style="line-height: 40px;">创建班级</span>
      </span>
      <!--<div class="lang">-->
      <!--{{lang}}-->
      <!--<ul class="ul">-->
      <!--<li class="li" @click="changeLanguage('ch')">中文简体</li>-->
      <!--<li class="li" @click="changeLanguage('en')">English</li>-->
      <!--</ul>-->
      <!--</div>-->
    </div>
    <CreateClass @hideDialog="hideDialog"></CreateClass>
    <UpdateClass></UpdateClass>
    <el-dialog
            :visible.sync="skipDialogVisible"
            width="30%"
            :close-on-click-modal="clickModalClose"
    >
      <div style="color: rgba(0,0,0,.85);">
        <h1 style="font-size: 18px; margin-bottom: 20px">{{teacherName + '老师，您好：'}}</h1>
        <p style="font-size: 16px; line-height: 1.5; text-indent: 2em">您已经成功注册全优在线，现在可以创建班级给学生上课。如果您需要我们介绍生源，请完善个人资料后等待工作人员联系。</p>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center; width: 100%; display: block">
                <el-button type="primary" @click="() => {skipDialogVisible = false; $store.commit('setAddClassDialog', true)}" style="margin-right: 60px">创建班级</el-button>
                <el-button type="primary" @click="() => {skipDialogVisible = false; $router.push('/console/myProfile')}">完善资料</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import CreateClass from 'components/createClass/CreateClass';
  import UpdateClass from 'components/updateClass/UpdateClass';
  export default{
    data(){
      const userInfo = loadLocal('userinfo');
      return{
        lang:'中文简体',
        teacherName: decodeURIComponent(userInfo.uname),
        role: userInfo.role,
        skipDialogVisible: this.$route.query.firstRegister? true: false,
        clickModalClose: false
      }
    },
    components: {
      CreateClass,
      UpdateClass
    },
    methods:{
      changeLanguage(text){
        if(text==='ch'){
          this.lang='中文简体';
          this.$i18n.locale = 'zh-CN';
          saveLocal('language','zh');
          this.$forceUpdate();
        }else if(text==='en'){
          this.lang='English';
          this.$i18n.locale = 'en-US';
          this.$forceUpdate();
          saveLocal('language','en');

          this.openChat();
        }
      },
      openChat() {
        let params = {};
        let routeData = this.$router.resolve({
          name: "chat",
          query: params,
          params:{}
        });
        window.open(routeData.href, '_blank');
      },

      // 隐藏创建班级弹窗
      hideDialog () {
        this.$store.commit('setAddClassDialog', false)
      }
    },
    created(){
      let language = loadLocal('language', false);
      if (language !== false) {
        if (language === 'en') {
          this.lang='English';
        } else {
          this.lang='中文简体';
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .above-nav
    position fixed
    left: 0
    top: 0
    right: 0
    height: 40px
    background #333
    .list
      text-align: center
      display: inline-block
      width: 160px
    .QR
      float: right
      margin-right: 20px
      width: 240px
      box-sizing: border-box
      font-size: 13px
      color: #ffffff
      text-align: center
      line-height: 40px
      position: relative
      cursor: pointer
      &::after
        content: ' ';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-left: 1px solid #fff;
        border-bottom: 1px solid #fff;
        transform: rotate(-45deg);
        transition-duration: 300ms;
        float:right
        position: relative;
        top:12px;
        right: 12px;
      &:hover::after
        transform: rotate(135deg);
        position: relative;
        top: 17px;
        right: 12px;
      &:hover .code
        display:block
      .code
        display: none
        position: absolute
        width: 240px
        background: #fff
        padding: 30px 0 22px
        box-sizing: border-box
        box-shadow 0 0 4px 2px rgba(0, 0, 0, 0.2)
        z-index:6000
        .img-wrapper
          margin: 0 auto
          width: 174px
          height: 174px
          margin-bottom: 14px
        .img-title
          font-size: 14px
          color: #666666
          line-height: 19px
          margin-bottom: 34px
        .code-text
          margin: 0 30px
          font-size: 13px
          color: #999999
          line-height: 18px
    .lang
      float:right
      font-size: 13px
      color: #ffffff
      line-height: 40px
      position: relative
      cursor: pointer
      &:hover .ul
        display block
      .ul
        display: none
        position: absolute
        padding:10px 0
        left:-30px
        width: 100px
        background: #fff
        box-sizing: border-box
        box-shadow 0 0 4px 2px rgba(0, 0, 0, 0.2)
        .li
          padding:0 10px
          text-align:center
          line-height: 39px
          font-size: 16px
          color: #333
          border-bottom 1px solid #e4e4e4
          &:last-child
            border:none

</style>



// WEBPACK FOOTER //
// src/components/abovenav/AboveNav.vue